import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/trumpet.png'


const _withScopeId = n => (_pushScopeId("data-v-007399f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { class: "high-light" }
const _hoisted_6 = { style: { color: '#F43838' } }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_8 = { class: "tip" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "销售跑店数据", -1))
const _hoisted_10 = { class: "mark" }
const _hoisted_11 = { class: "ranking" }
const _hoisted_12 = { class: "mark" }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Tabs, Tab, Overlay, Loading, Empty } from "vant";
import { formatPercentage } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'Offline',
  setup(__props) {

const route = useRoute();
const active = ref(0);

const visible = ref(false);
const pageData = ref<any>({});
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/offline/getVisitSummary",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      adminFlag: true,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

// 区域排行
const areaList = ref<any>([]);
const getProductsData = async () => {
  const res = await request({
    url: "/api/wx/offline/list-area-visit-store",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      adminFlag: true,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
    // params: {
    //   openId: 'o7Gwj6b4bHVGwrEVKckufk8jjIh4',
    // },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    areaList.value = res.data;
    if (res.data?.[0]?.name) {
      handleClick(res.data[0].name, 0);
    }
  } else {
    // showFailToast(res.data);
  }
};
getProductsData();

// 选择区域
const selectedArea = ref("");
const visitShopList = ref<any[]>([]);
const handleClick = async (area: string, index = 0) => {
  selectedArea.value = area;
  active.value = index;
  const res = await request({
    url: "/api/wx/offline/list-sales-visit-store",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      officeName: area,
      adminFlag: true,
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    visitShopList.value = res.data;
  } else {
    // showFailToast(res.data);
  }
};

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              title: "当日拜访店铺总量：",
              size: "large",
              class: "bold",
              "title-style": { flex: 'inherit' }
            }, {
              value: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(pageData.value.value), 1),
                  _createTextVNode(" (环比："),
                  _createElementVNode("span", {
                    style: _normalizeStyle({ color: pageData.value.percentage >= 0 ? 'red' : 'green' })
                  }, _toDisplayString(`${pageData.value.percentage >= 0 ? "+" : ""}${_unref(formatPercentage)(
                      pageData.value.percentage
                    )}`), 5),
                  _createTextVNode(") ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_7,
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("img", {
            style: _normalizeStyle({ width: '0.28rem' }),
            src: _imports_0,
            alt: ""
          }, null, 4),
          _createTextVNode(" 点击某一区域名称，下方会联动展示该区域下对应的销售跑店排行榜 ")
        ]),
        _hoisted_9,
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              title: "区域",
              value: "跑店数量",
              style: { background: '#E5F6F4', fontWeight: 500 }
            }),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
                return (_openBlock(), _createBlock(_unref(Cell), {
                  class: _normalizeClass({ active: active.value === index }),
                  style: _normalizeStyle({ fontSize: '0.3rem' }),
                  key: index,
                  title: item.name.replace(/六律/, ''),
                  onClick: ($event: any) => (handleClick(item.name, index))
                }, {
                  value: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass({ active: active.value === index })
                    }, _toDisplayString(item.value), 3),
                    _createTextVNode("(环比："),
                    _createElementVNode("span", {
                      style: _normalizeStyle({
                    color:
                      item.extendAttributes?.percentage >= 0 ? 'red' : 'green',
                  })
                    }, _toDisplayString(`${
                      item.extendAttributes?.percentage >= 0 ? "+" : ""
                    }${_unref(formatPercentage)(item.extendAttributes?.percentage)}`), 5),
                    _createTextVNode(") ")
                  ]),
                  _: 2
                }, 1032, ["class", "style", "title", "onClick"]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        (!areaList.value.length)
          ? (_openBlock(), _createBlock(_unref(Empty), {
              key: 0,
              description: "暂无数据",
              "image-size": "100"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_11, _toDisplayString(selectedArea.value.replace(/六律/, "")) + "销售跑店排行榜 ", 1),
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Cell), {
              style: { background: '#E5F6F4', fontWeight: 500 },
              title: "销售姓名",
              value: "跑店数量"
            })
          ]),
          _: 1
        }),
        (!visitShopList.value?.length)
          ? (_openBlock(), _createBlock(_unref(Empty), {
              key: 1,
              description: "暂无数据",
              "image-size": "100"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visitShopList.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(Cell), {
              key: index,
              title: item.name,
              style: _normalizeStyle({ fontSize: '0.3rem' })
            }, {
              value: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.value) + " (环比：", 1),
                _createElementVNode("span", {
                  style: _normalizeStyle({
                  color:
                    item.extendAttributes?.percentage >= 0 ? 'red' : 'green',
                })
                }, _toDisplayString(`${
                    item.extendAttributes?.percentage >= 0 ? "+" : ""
                  }${_unref(formatPercentage)(item.extendAttributes?.percentage)}`), 5),
                _createTextVNode(") ")
              ]),
              _: 2
            }, 1032, ["title", "style"]))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})